import React, { Component,Fragment } from 'react'

class Topic extends Component {
  constructor(){
    super();
    this.state = {
      focused: true,
      hotList: ['原片','白玻','夹胶','镀膜玻璃','钢化玻璃','镀膜玻璃'],
      hotList2: [],
      inputValue: '',
      focusedList: ['原片', '白玻', '夹胶', '镀膜玻璃','钢化玻璃']
    }
  }
  render() {
    return (
      <Fragment>
        <div className='center960 flex-row-between'>
          <img className='toplogo' src='/pics/lkd-logo.png' alt="青岛利凯达网络科技有限公司" />
          <div className='topRight'>
            <div className='navSearch'>
              <input className='navInput' onFocus={this.hotActive.bind(this)}
               onBlur={this.hotInactive.bind(this)} onChange={this.inputChange.bind(this)} />
              <button className='navBtn'>搜索</button>
            </div>
            <div className='topRight'>
              {
                this.state.focusedList.map((item,index)=>{
                  return <div className='navFocused' key = {index}>{item}</div>
                })
              } <div  className='navFocused'>(热门搜索)</div>
            </div>
            <div  className={this.state.focused? 'navHot active':'navHot inactive'} >
              {
                this.state.hotList2.map((item,index)=>{
                  return <div key={index}>{item}</div>
                })
              }
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
  hotActive(){
    let list = JSON.parse(JSON.stringify(this.state.hotList));
    this.setState({
      focused: true,
      hotList2: list
    })
  }
  hotInactive(){
    this.setState({
      focused: false
    })
  }
  inputChange(e){
    let fixedValue = '';
    if(e.target.value.length >0){
      fixedValue = '正在检索：'+e.target.value;      
      this.setState({
        hotList2: [fixedValue, ...this.state.hotList]
      })
    }else{      
      this.setState({
        hotList2: [ ...this.state.hotList]
      })
    }
    
  }
}

export default Topic;
